<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0001 1.66663C5.39175 1.66663 1.66675 5.39163 1.66675 9.99996C1.66675 14.6083 5.39175 18.3333 10.0001 18.3333C14.6084 18.3333 18.3334 14.6083 18.3334 9.99996C18.3334 5.39163 14.6084 1.66663 10.0001 1.66663ZM14.1667 12.9916L12.9917 14.1666L10.0001 11.175L7.00842 14.1666L5.83342 12.9916L8.82508 9.99996L5.83342 7.00829L7.00842 5.83329L10.0001 8.82496L12.9917 5.83329L14.1667 7.00829L11.1751 9.99996L14.1667 12.9916Z"
      fill="#888888"
    />
  </svg>
</template>
